import { Logger } from "./logger";
export var XHRDataType;
(function (XHRDataType) {
    XHRDataType[XHRDataType["FORM"] = 0] = "FORM";
    XHRDataType[XHRDataType["JSON"] = 1] = "JSON";
})(XHRDataType || (XHRDataType = {}));
export class XHR {
    static call(url, method, data = null) {
        return new Promise((resolve, reject) => {
            Logger.verbose("Calling Tracking API. Endpoint => " + url);
            let objData = {};
            if (data) {
                //Logger.verbose("Data");
                Logger.verbose("============ XHR API Request Data =============");
                const result = Array.isArray(data);
                // FormDataEntryValue  == data: Nullable<FormData> = null
                objData = data;
                if (result) {
                    data.forEach((value, key) => {
                        if (XHR._dataType == XHRDataType.JSON) {
                            //objData[key] = value;
                        }
                        Logger.verbose(key, " => ", value);
                    });
                }
                else {
                    Logger.verbose(data);
                }
                Logger.verbose("===============================================");
            }
            var xhr = new XMLHttpRequest();
            xhr.addEventListener('load', function () {
                //Logger.verbose("Respnose");
                Logger.verbose("=========== XHR Respnose ======================");
                Logger.verbose("Return Code => " + this.status);
                Logger.verbose("Raw Body => " + this.responseText);
                Logger.verbose("===============================================");
                resolve(this);
            });
            xhr.addEventListener('abort', function (e) {
                Logger.error("Tracking API aboarted");
                reject(this);
            });
            xhr.addEventListener('error', function (e) {
                Logger.verbose("=========== Tracking API erro =================");
                //Logger.error("Tracking API error");
                Logger.verbose("Response Code => " + this.status);
                Logger.verbose("Response body => " + this.responseText);
                Logger.verbose("===============================================");
                reject(this);
            });
            xhr.open(method, url, true); // sync, true - async
            xhr.setRequestHeader("Content-Type", "application/json;charset=UTF-8");
            if (data) {
                xhr.send(XHR._dataType == XHRDataType.FORM ? data : JSON.stringify(objData));
            }
            else {
                xhr.send();
            }
        });
    }
}
XHR._dataType = XHRDataType.JSON;
